import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

export interface ApiPostDeliveryAddressPayload {
    token: string;
    deviceId: string;
    contactFirstName: string;
    contactLastName: string;
    contactPhone: string;
    contactEmail: string;
    index: string;
    city: string;
    street: string;
    houseNum: string;
    apartmentNum: string;
    deliveryService: "in_post";
    deliveryType: "courier" | "locker";
    customField1?: string;
    customField2?: string;
    customField3?: string;
    customField4?: string;
}

export async function apiPostDeliveryAddress(payload: ApiPostDeliveryAddressPayload) {
    const fetchData = await axios.post<void>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/device/delivery-address`,
        // @ts-expect-error
        new URLSearchParams(payload),
    );

    return fetchData.data;
}
